import { Fragment, type FC, type PropsWithChildren } from 'react';
import SelectBoxStyles from '../InputBox/TextBox.module.css';
import { isDisabled } from '@testing-library/user-event/dist/utils';

type SelectBoxProps = PropsWithChildren<{
  name?: string;
  icon?: string;
  value: string;
  locked?: boolean;
  errorMessage?: string;
  label: string;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  inputContainerStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  inputContainerClass?:string
  labelClass?:string
  containerClass?:string
  inputClass?:string
  isDisabled?:boolean
}>;

const SelectBox: FC<SelectBoxProps> = ({
  children,
  name,
  label,
  icon,
  value,
  onChange,
  locked,
  errorMessage,
  style,
  containerStyle,
  inputContainerStyle,
  labelStyle,
  inputContainerClass,
  labelClass,
  containerClass,
 inputClass,
 isDisabled
}) => {

    const disabledClass = isDisabled ? SelectBoxStyles.disabled : '';
  return (
    <div className={`${SelectBoxStyles.form_input} ${containerClass} ${disabledClass}`} style={containerStyle}>
      {label && (
        <label htmlFor={label} className={`${SelectBoxStyles.form_input__label} ${labelClass}`} style={labelStyle} >
          {label}
        </label>
      )}
      <div className={`${SelectBoxStyles.form_input__container} ${inputContainerClass}`} style={inputContainerStyle || style}>
        {!locked ? (
          <Fragment>
            {icon && (
              <svg className={SelectBoxStyles.form_input__icon}>
                <use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
              </svg>
            )}
            <select
              value={value}
              name={name}
              id={name}
              className={`${SelectBoxStyles.form_input__box} ${inputClass}`}
              onChange={onChange}
              style={style}
              disabled={isDisabled}
            >
              {children}
            </select>
          </Fragment>
        ) : (
          <Fragment>
            <p
              className={SelectBoxStyles.form_input__box}
              style={{
                height: '1.5rem',
                lineHeight: '1',
                color: value ? 'var(--grey)' : 'var(--light-grey)',
                ...(style || {}),
              }}
            >
              {value ? value : label}
            </p>
            <svg className={SelectBoxStyles.form_input__icon}>
              <use xlinkHref={`/assets/sprite.svg#icon-lock`} />
            </svg>
          </Fragment>
        )}
      </div>
      {errorMessage && <p className={SelectBoxStyles.form_input__error}>{errorMessage}</p>}
    </div>
  );
};

export default SelectBox;